import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import SEOHead from "@/components/base/SEOHead";
import { useState } from "react";
import ScrollReveal from "@/components/base/ScrollReveal";
import FeaturedArticles from "./components/FeaturedArticles";

const categories = [
  "全部",
  "保單與保障趨勢",
  "資產配置與市場波動",
  "教育金、退休金與長照議題",
  "企業風險與法遵制度",
  "傳承、信託與家族治理",
  "整合規劃",
];

interface Article {
  title: string;
  summary: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  content: string;
}

const articles: Article[] = [
  {
    title: "為什麼保單需要定期健診？",
    summary:
      "家庭責任、醫療制度、收入狀況與人生階段都會改變，舊保單不一定符合現在需求。",
    category: "保單與保障趨勢",
    date: "2026.04.20",
    readTime: "5 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20insurance%20policy%20documents%20under%20warm%20golden%20spotlight%20on%20dark%20desk%2C%20magnifying%20glass%20revealing%20fine%20print%20details%2C%20premium%20professional%20audit%20aesthetic%2C%20dark%20background%20with%20elegant%20gold%20lighting%2C%20sophisticated%20and%20meticulous%20atmosphere%2C%204K%20quality&width=600&height=340&seq=401&orientation=landscape",
    content: `很多人買了保險後就再也沒有檢視過，但其實保單就像身體健康檢查一樣，需要定期盤點。當你結婚、生子、買房、換工作、甚至只是健保制度調整，原本規劃的保障可能就與現實脫節。

最常見的健診發現包括：重複投保造成保費浪費、醫療險保額跟不上現在的住院費用、受益人還寫著已經分手的前伴侶、或者重大傷病險條件已經過時，新的治療方式根本不賠。

保險門神的保單健診服務，會將你所有的保單整理成一份「保障地圖」，清楚標示每一張保單的功能、保障內容與缺口。我們不會為了賣新保單而叫你亂買，而是先釐清你「真正需要什麼」，再決定哪些該保留、哪些該調整、哪些該補強。定期健診的價值，在於讓每一分保費都花在刀口上，也讓你在風險發生時，真正拿到應有的保障。`,
  },
  {
    title: "資產配置不是只看報酬，而是先看風險",
    summary:
      "真正成熟的配置，應該先考慮生活現金流、預備金、保障與波動承受度。",
    category: "資產配置與市場波動",
    date: "2026.04.12",
    readTime: "6 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Balanced%20golden%20scale%20with%20wealth%20symbols%20on%20dark%20background%2C%20abstract%20stock%20chart%20lines%20flowing%20in%20warm%20gold%20light%2C%20risk%20management%20and%20asset%20allocation%20concept%2C%20premium%20financial%20planning%20aesthetic%2C%20dark%20tones%20with%20elegant%20gold%20accents%2C%204K%20quality&width=600&height=340&seq=402&orientation=landscape",
    content: `投資市場最迷人的是「高報酬」三個字，但也是最危險的陷阱。很多人因為看到別人賺了錢就追高，市場下跌又恐慌殺低，最終不是沒賺到，而是賠掉了本金與信心。

資產配置的第一步不是選標的，而是先問自己：生活現金流需要多少？緊急預備金存夠了嗎？保險保障有沒有缺口？能承受多少波動？這些問題的答案，會決定你應該把錢怎麼分配。

保險門神的財產門神服務，會先協助你釐清這些底層問題。我們將資產分成生活帳戶、緊急預備金、保障帳戶、投資帳戶與長期目標帳戶，並為每個帳戶設定比例與再平衡規則。這不是「買什麼會賺」的建議，而是「你的錢該怎麼站崗」的策略。

先守風險，後追報酬。這句話聽起來保守，但卻是讓財富穩健增加的真正方法。`,
  },
  {
    title: "教育金與退休金，為什麼不能分開看？",
    summary:
      "家庭現金流有限，若沒有整合規劃，容易顧了孩子卻犧牲退休安全。",
    category: "教育金、退休金與長照議題",
    date: "2026.03.28",
    readTime: "5 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Stack%20of%20books%20and%20graduation%20cap%20beside%20a%20calendar%20and%20clock%20on%20dark%20surface%2C%20warm%20golden%20light%20illuminating%20educational%20and%20retirement%20planning%20symbols%2C%20premium%20life%20milestone%20aesthetic%2C%20dark%20background%20with%20gold%20accents%2C%20thoughtful%20and%20forward-looking%20atmosphere%2C%204K%20quality&width=600&height=340&seq=403&orientation=landscape",
    content: `台灣家庭的常見困境是：為了孩子的才藝班、補習費、出國留學，把退休準備的金額一再壓縮。等到孩子獨立了，才發現自己的退休缺口已經來不及補。

教育金與退休金看似是兩件事，其實它們共用同一個「家庭現金流池」。如果不做整合規劃，很容易在情感上優先滿足孩子，理性上卻犧牲了自己的未來。

人生門神的整合規劃方法，是先把全家的現金流、資產負債與人生時間表攤開來看，再依優先順序分配資源。我們會協助你建立「教育金路線圖」與「退休現金流設計」，讓兩個目標在同一張地圖上彼此協調。

關鍵原則是：教育金可以彈性（孩子可以讀公立或申請獎學金），但退休時間無法延後。整合規劃不是讓你選一個，而是讓兩個都能達到。`,
  },
  {
    title: "企業主最容易忽略的三種風險",
    summary:
      "人事制度、負責人保障與企業傳承，往往比營收更容易在關鍵時刻影響企業存續。",
    category: "企業風險與法遵制度",
    date: "2026.03.15",
    readTime: "7 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20corporate%20building%20silhouette%20with%20protective%20shield%20symbol%20glowing%20in%20warm%20gold%20on%20dark%20background%2C%20abstract%20business%20risk%20management%20concept%2C%20premium%20enterprise%20governance%20aesthetic%2C%20dark%20tones%20with%20powerful%20gold%20lighting%2C%20authoritative%20and%20secure%20atmosphere%2C%204K%20quality&width=600&height=340&seq=404&orientation=landscape",
    content: `中小企業主每天都在忙營收、交貨、收款，卻常常忽略三件事：

第一是「人事制度的法遵風險」。很多公司的勞動契約是公版、工作規則多年未更新，特休與加班制度也不清楚。一旦遇到勞檢或爭議，才發現制度漏洞百出。

第二是「負責人本身的保障缺口」。企業主常常把錢全投在公司裡，自己卻沒有足夠的醫療、意外與壽險保障。萬一自己出事，公司可能立刻陷入經營危機。

第三是「沒有傳承規劃」。很多企業主以為接班就是「把股權交給孩子」，但沒有考慮股權如何移轉、家族成員如何分工、稅務如何規劃。結果人走了，企業也散了。

企業門神的價值，就是幫企業主從薪資結構、人事制度、團險規劃到傳承架構，建立一套完整的企業防線。這不是花錢，而是為企業買長期的平安。`,
  },
  {
    title: "保險金信託適合誰？",
    summary:
      "當資產、照護責任與家庭成員期待交錯時，信託能協助讓資金流向更清楚。",
    category: "傳承、信託與家族治理",
    date: "2026.02.22",
    readTime: "6 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20envelope%20and%20trust%20document%20with%20golden%20wax%20seal%20on%20dark%20mahogany%20surface%2C%20abstract%20flowing%20gold%20light%20connecting%20family%20generations%2C%20premium%20inheritance%20planning%20aesthetic%2C%20dark%20background%20with%20warm%20gold%20accents%2C%20trustworthy%20and%20solemn%20atmosphere%2C%204K%20quality&width=600&height=340&seq=405&orientation=landscape",
    content: `當身故或失能時，保險金或資產該怎麼給？一次給完，可能讓受益人不知如何運用；分批給，又擔心執行困難。這時候，保險金信託就能發揮作用。

保險金信託的核心精神是「錢的流向由你決定」。你可以在生前就規劃好：保險金進入信託後，每月給父母多少生活費？孩子的教育費怎麼撥？誰來當監察人確保信託執行？

特別適合以下情境：有未成年子女需要長期照顧、有身心障礙家人需要終身支持、家庭成員之間對資產分配有不同意見、或者單純希望保險金「慢慢給」而不是「一次花光」。

人生門神的傳承規劃服務，會協助你評估是否需要保險金信託，並與保單設計、資產配置與家族治理做整體搭配。信託不是有錢人的專利，而是讓愛延續的方法。`,
  },
  {
    title: "一份好的財務規劃，應該回答哪些問題？",
    summary:
      "不是買什麼商品，而是回答風險在哪裡、錢要去哪裡、何時需要調整。",
    category: "整合規劃",
    date: "2026.02.08",
    readTime: "5 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Golden%20compass%20and%20roadmap%20on%20dark%20surface%20with%20abstract%20destination%20markers%20glowing%20in%20warm%20gold%20light%2C%20financial%20journey%20planning%20concept%2C%20premium%20wealth%20advisory%20aesthetic%2C%20dark%20background%20with%20elegant%20gold%20accents%2C%20clear%20and%20purposeful%20atmosphere%2C%204K%20quality&width=600&height=340&seq=406&orientation=landscape",
    content: `很多人找財務顧問時，第一個問題是「我該買什麼？」但保險門神認為，真正重要的問題是這三個：

「風險在哪裡？」——你最大的財務風險是醫療？失能？市場波動？還是家庭責任？不同的風險需要不同的防線。

「錢要去哪裡？」——你的收入、支出、負債、保費、投資與儲蓄，每一塊錢都該有它的位置。亂放的錢，效率就是浪費。

「何時需要調整？」——財務規劃不是一次做完就永遠有效。結婚、買房、生子、升遷、退休，每個人生階段都需要重新檢視。

好的財務規劃不是一份精美的報告，而是一張「活的地圖」——它讓你隨時知道自己的位置、目標與路徑，也知道什麼時候該轉彎。保險門神的整合規劃，就是為你畫這張地圖，並陪你一路走到目的地。`,
  },
  {
    title: "長期照護風險：你準備好了嗎？",
    summary:
      "台灣正邁入超高齡社會，長照支出可能侵蝕退休準備。了解長照險、失能險與實支實付的差異，提前建立防護網。",
    category: "教育金、退休金與長照議題",
    date: "2026.01.20",
    readTime: "6 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Caring%20hands%20holding%20golden%20hourglass%20on%20dark%20background%2C%20subtle%20medical%20cross%20and%20heart%20symbols%20floating%20in%20warm%20golden%20light%2C%20long-term%20care%20and%20aging%20preparation%20concept%2C%20premium%20healthcare%20planning%20aesthetic%2C%20dark%20tones%20with%20elegant%20gold%20accents%2C%20compassionate%20and%20secure%20atmosphere%2C%204K%20quality&width=600&height=340&seq=408&orientation=landscape",
    content: `根據國家發展委員會預估，台灣將在 2025 年進入「超高齡社會」，65 歲以上人口占比超過 20%。這意味著長期照護的需求將快速增加，而長照費用往往比想像中更高。

許多人以為「長照險」就是解決方案，但其實保險市場上有三種不同的工具：長照險、失能險與實支實付醫療險。長照險主要看「認知障礙或無法執行日常生活活動」；失能險則是依失能等級給付；實支實付則是補貼醫療費用。三者功能不同，適合不同情況。

更令人擔憂的是，長照支出往往不是一年兩年，而是五年、十年甚至更久。如果沒有提前規劃，這些費用可能會快速侵蝕原本為退休準備的資產。

人生門神的規劃會協助你評估家庭長照風險，並依照你的預算與需求，建議合適的保障組合。我們也會將長照規劃納入退休現金流設計，確保即使需要長照，退休生活也不會瞬間崩塌。`,
  },
  {
    title: "市場下跌時，為什麼紀律比勇氣更重要？",
    summary:
      "恐慌性賣出往往是最大損失來源。建立再平衡規則與情緒管理機制，才能在波動中守住長期配置成果。",
    category: "資產配置與市場波動",
    date: "2026.01.12",
    readTime: "5 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Golden%20anchor%20holding%20steady%20in%20turbulent%20dark%20waters%20with%20abstract%20storm%20waves%20and%20lightning%2C%20discipline%20and%20stability%20concept%20in%20financial%20markets%2C%20premium%20resilience%20aesthetic%2C%20dark%20background%20with%20powerful%20gold%20accents%2C%20calm%20and%20unwavering%20atmosphere%2C%204K%20quality&width=600&height=340&seq=409&orientation=landscape",
    content: `當市場大跌時，最常見的反應有兩種：「趕快賣掉止損」或「趁低點全部買進」。兩種都需要勇氣，但兩種都可能讓你錯過長期配置的成果。

真正有效的做法，是在市場平穩時就建立「再平衡規則」。例如：當股票佔比因為上漲超過 60%，就賣出一部分轉入債券；當股票佔比因為下跌低於 40%，就從債券轉入股票。這個規則不需要勇氣，只需要紀律。

問題是，絕大多數人沒有這個規則。所以他們在市場高點時股票佔比過高（因為漲最多），在市場低點時股票佔比過低（因為不敢買）。結果變成「追高殺低」的完美範例。

財產門神的資產配置服務，會為你設計專屬的資金分艙與再平衡規則。我們不預測市場，但我們幫你建立「不管市場怎麼走，都知道該怎麼做」的系統。紀律不是限制，而是保護。`,
  },
  {
    title: "團體保險與員工福利：中小企業的隱形競爭力",
    summary:
      "完善的團險與福利制度不只能降低企業主風險，更是吸引與留住人才的關鍵。了解如何設計符合預算又具吸引力的方案。",
    category: "企業風險與法遵制度",
    date: "2025.12.28",
    readTime: "6 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Golden%20puzzle%20pieces%20forming%20protective%20shield%20around%20diverse%20team%20silhouettes%20on%20dark%20background%2C%20employee%20benefits%20and%20group%20insurance%20concept%2C%20premium%20corporate%20welfare%20aesthetic%2C%20dark%20tones%20with%20warm%20gold%20accents%2C%20collaborative%20and%20secure%20atmosphere%2C%204K%20quality&width=600&height=340&seq=410&orientation=landscape",
    content: `在人才競爭激烈的時代，薪資不再是唯一的留人工具。越來越多求職者會問：「公司有沒有團體保險？」、「保障內容是什麼？」對於中小企業來說，設計一套好的團險與福利制度，成本可能沒有想像中高，效益卻非常顯著。

但許多企業主對團險的理解停留在「買一張團保就結束」。其實團險應該與薪資結構、員工需求與企業預算整合考量。例如年輕員工可能重視意外與醫療，中年員工可能關注壽險與重疾，高階主管則需要更完整的保障規劃。

更重要的是，團險不只是員工福利，也是企業主風險管理的一部分。當員工發生職災或重大疾病時，完善的團險可以大幅降低企業的連帶責任與補償壓力。

企業門神的服務，會先了解你的產業特性、員工結構與預算，再建議最適合的團險與福利組合。我們也會協助你建立員工溝通機制，讓福利真的被感受到，而不只是「花錢買心安」。`,
  },
  {
    title: "二代接班前，企業主該先完成的三件事",
    summary:
      "接班不只是股權移轉，更是治理制度、家族共識與風險隔離的整體工程。提早規劃，才能讓企業穩健傳承。",
    category: "傳承、信託與家族治理",
    date: "2025.12.15",
    readTime: "7 分鐘",
    image:
      "https://readdy.ai/api/search-image?query=Golden%20key%20being%20passed%20between%20two%20hands%20across%20generations%20on%20dark%20background%2C%20abstract%20bridge%20of%20light%20connecting%20past%20and%20future%2C%20business%20succession%20and%20family%20legacy%20concept%2C%20premium%20inheritance%20planning%20aesthetic%2C%20dark%20tones%20with%20elegant%20gold%20accents%2C%20timeless%20and%20visionary%20atmosphere%2C%204K%20quality&width=600&height=340&seq=411&orientation=landscape",
    content: `台灣中小企業普遍面臨接班問題，但很多企業主直到身體出狀況或年紀大了，才開始想「該交給誰」。這時候往往已經來不及妥善規劃。

在考慮「交給誰」之前，企業主應該先完成三件事：

第一是「治理制度文件化」。很多企業的運作靠老闆的經驗與人脈，沒有清楚的制度與流程。接班後，新人接不上手，企業立刻陷入混亂。

第二是「家族共識的建立」。接班不只是老闆與接班人之間的事，還涉及其他家族成員的期待與角色。沒有共識的接班，容易引發內鬥與資產爭議。

第三是「風險隔離與傳承架構」。透過保險、信託與股權設計，讓企業資產與家族資產適度分離。這樣即使企業經營遇到困難，也不會拖累家族生活。

企業門神的傳承規劃服務，會協助企業主從這三件事切入，建立一套可執行、可調整的接班藍圖。接班不是終點，而是企業新生命的起點。`,
  },
];

export default function Insights() {
  const [activeCategory, setActiveCategory] = useState("全部");
  const [selectedArticle, setSelectedArticle] = useState<Article | null>(null);

  const filtered =
    activeCategory === "全部"
      ? articles
      : articles.filter((a) => a.category === activeCategory);

  const openArticle = (article: Article) => {
    setSelectedArticle(article);
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      const drawer = document.querySelector('[data-drawer-panel]');
      if (drawer) drawer.scrollTop = 0;
    }, 50);
  };

  const closeArticle = () => {
    setSelectedArticle(null);
    document.body.style.overflow = "";
  };

  return (
    <div className="min-h-screen bg-brand-black">
      <SEOHead
        title="市場趨勢動態 | 保險・資產・傳承觀點 | 保險門神"
        description="保險門神市場趨勢動態，整理保險、資產配置、退休規劃、企業治理與傳承規劃的重要觀點與深度文章，協助你看懂風險變化，提前做好準備。"
        keywords="保險趨勢,資產配置觀點,退休規劃文章,企業風險管理,財富傳承知識"
        canonicalPath="/insights"
        ogType="website"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Blog",
          "name": "保險門神市場趨勢動態",
          "description": "保險、資產配置、退休規劃、企業治理與傳承規劃的重要觀點與深度文章。",
          "url": "__SITE_URL__/insights",
          "blogPost": articles.slice(0, 10).map((a, i) => ({
            "@type": "BlogPosting",
            "headline": a.title,
            "description": a.summary,
            "url": "__SITE_URL__/insights",
            "datePublished": a.date,
            "image": a.image
          })),
          "isPartOf": {
            "@type": "WebSite",
            "name": "保險門神 Insurance Guardian",
            "url": "__SITE_URL__/"
          }
        }}
      />
      <Header />
      <main>
        {/* Hero */}
        <section className="relative pt-24 md:pt-32 pb-12 md:pb-16 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20luxury%20background%20with%20golden%20flowing%20market%20data%20and%20trend%20lines%20on%20deep%20black%20canvas%2C%20subtle%20newspaper%20and%20chart%20motifs%20in%20warm%20gold%20light%2C%20premium%20financial%20insights%20brand%20aesthetic%2C%20sophisticated%20minimalist%20composition%2C%20knowledge%20and%20foresight%20atmosphere%2C%20dark%20tones%20with%20elegant%20gold%20accents%2C%20cinematic%20mood%2C%204K%20quality&width=1920&height=600&seq=407&orientation=landscape"
              alt="市場趨勢動態 Hero 背景"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />
          </div>
          <div className="container-main relative z-10 text-center">
            <div className="inline-block border border-brand-border rounded-full px-5 py-2 mb-6">
              <span className="text-brand-gold text-[1rem] font-medium tracking-wide">
                市場趨勢動態
              </span>
            </div>
            <h1 className="text-white font-display font-bold text-[2rem] md:text-[2.75rem] leading-[1.3] md:leading-[1.25] mb-4">
              市場趨勢動態
            </h1>
            <p className="text-brand-text-secondary text-[1.1875rem] leading-[1.75] max-w-[680px] mx-auto">
              看懂風險變化，才能提前做好準備。這裡整理保險、資產配置、退休、企業治理與傳承規劃的重要觀點。
            </p>
            <div className="w-[60px] h-[2px] bg-brand-gold mx-auto mt-4" />
          </div>
        </section>

        {/* Featured Articles */}
        <FeaturedArticles articles={articles} onOpenArticle={openArticle} />

        {/* Category Filter */}
        <section className="pb-8 md:pb-10">
          <div className="container-main">
            <div className="flex flex-wrap gap-2 md:gap-3">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setActiveCategory(cat)}
                  className={`px-4 py-2 rounded-full text-[0.9375rem] md:text-[1rem] font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat
                      ? "bg-brand-gold text-brand-black"
                      : "border border-brand-border text-brand-text-secondary hover:text-white hover:border-brand-gold/60"
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="pb-20 md:pb-28">
          <div className="container-main">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((article, index) => (
                <div
                  key={index}
                  className="group bg-brand-card border border-brand-border rounded-2xl overflow-hidden transition-all duration-300 hover:border-brand-gold/50 flex flex-col"
                >
                  {/* Cover Image */}
                  <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden cursor-pointer"
                    onClick={() => openArticle(article)}
                  >
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-card via-transparent to-transparent" />
                  </div>

                  <div className="p-6 md:p-7 flex flex-col flex-1">
                    {/* Category Tag */}
                    <div className="mb-4">
                      <span className="inline-block border border-brand-border rounded-full px-3 py-1 text-brand-gold text-[0.875rem] font-medium">
                        {article.category}
                      </span>
                    </div>

                    {/* Title */}
                    <h3 className="text-white font-semibold text-[1.25rem] md:text-[1.5rem] leading-[1.45] mb-3 group-hover:text-brand-gold transition-colors cursor-pointer"
                      onClick={() => openArticle(article)}
                    >
                      {article.title}
                    </h3>

                    {/* Summary */}
                    <p className="text-brand-text-secondary text-[1.0625rem] leading-[1.75] mb-5 flex-1">
                      {article.summary}
                    </p>

                    {/* Meta */}
                    <div className="flex items-center justify-between pt-4 border-t border-brand-border">
                      <div className="flex items-center gap-3 text-brand-text-secondary text-[0.9375rem]">
                        <span>{article.date}</span>
                        <span className="w-1 h-1 rounded-full bg-brand-border" />
                        <span>{article.readTime}</span>
                      </div>
                      <button
                        onClick={() => openArticle(article)}
                        className="flex items-center gap-1.5 text-brand-gold text-[0.9375rem] font-medium group-hover:gap-2 transition-all cursor-pointer"
                      >
                        閱讀更多
                        <i className="ri-arrow-right-line" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filtered.length === 0 && (
              <div className="text-center py-16">
                <p className="text-brand-text-secondary text-[1.1875rem]">
                  此分類暫無文章
                </p>
              </div>
            )}
          </div>
        </section>

        {/* Article Drawer */}
        {selectedArticle && (
          <div className="fixed inset-0 z-[1000]" onClick={closeArticle}>
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />

            {/* Drawer Panel */}
            <div
              data-drawer-panel
              className="absolute right-0 top-0 h-full w-full md:w-[680px] lg:w-[760px] bg-brand-card border-l border-brand-border overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={closeArticle}
                className="sticky top-0 z-10 ml-auto mr-4 mt-4 w-10 h-10 flex items-center justify-center rounded-full bg-brand-black border border-brand-border text-brand-gold hover:border-brand-gold transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl" />
              </button>

              <div className="px-6 md:px-10 pb-10 -mt-10">
                {/* Cover */}
                <div className="relative w-full h-[220px] md:h-[280px] rounded-2xl overflow-hidden mb-8">
                  <img
                    src={selectedArticle.image}
                    alt={selectedArticle.title}
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-card via-black/30 to-transparent" />
                </div>

                {/* Category */}
                <span className="inline-block border border-brand-border rounded-full px-3 py-1 text-brand-gold text-[0.875rem] font-medium mb-4">
                  {selectedArticle.category}
                </span>

                {/* Title */}
                <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2rem] leading-[1.35] mb-4">
                  {selectedArticle.title}
                </h2>

                {/* Meta */}
                <div className="flex items-center gap-3 text-brand-text-secondary text-[0.9375rem] mb-8 pb-6 border-b border-brand-border">
                  <span>{selectedArticle.date}</span>
                  <span className="w-1 h-1 rounded-full bg-brand-border" />
                  <span>{selectedArticle.readTime}</span>
                </div>

                {/* Content */}
                <div className="prose prose-invert max-w-none">
                  {selectedArticle.content.split("\n\n").map((paragraph, idx) => (
                    <p
                      key={idx}
                      className="text-brand-text-secondary text-[1.0625rem] md:text-[1.125rem] leading-[1.8] mb-5"
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>

                {/* Related Articles */}
                {(() => {
                  const related = articles
                    .filter(
                      (a) =>
                        a.category === selectedArticle.category &&
                        a.title !== selectedArticle.title
                    )
                    .slice(0, 3);
                  if (related.length === 0) return null;
                  return (
                    <div className="mt-10 pt-6 border-t border-brand-border">
                      <h3 className="text-white font-semibold text-[1.125rem] md:text-[1.25rem] mb-5">
                        你可能也感興趣
                      </h3>
                      <div className="space-y-4">
                        {related.map((article) => (
                          <button
                            key={article.title}
                            onClick={() => {
                              setSelectedArticle(article);
                              // scroll to top of drawer content
                              const drawer = document.querySelector(
                                '[data-drawer-panel]'
                              );
                              if (drawer) drawer.scrollTop = 0;
                            }}
                            className="flex items-start gap-4 w-full text-left group cursor-pointer"
                          >
                            <div className="w-24 h-16 md:w-28 md:h-[72px] rounded-lg overflow-hidden flex-shrink-0 border border-brand-border group-hover:border-brand-gold/50 transition-colors">
                              <img
                                src={article.image}
                                alt={article.title}
                                className="w-full h-full object-cover object-center"
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <span className="text-brand-gold text-[0.8125rem] font-medium">
                                {article.category}
                              </span>
                              <h4 className="text-white text-[1rem] md:text-[1.0625rem] font-medium leading-[1.5] mt-1 group-hover:text-brand-gold transition-colors line-clamp-2">
                                {article.title}
                              </h4>
                              <div className="flex items-center gap-2 text-brand-text-secondary/70 text-[0.8125rem] mt-1.5">
                                <span>{article.date}</span>
                                <span className="w-1 h-1 rounded-full bg-brand-border" />
                                <span>{article.readTime}</span>
                              </div>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })()}

                {/* Bottom CTA */}
                <div className="mt-10 pt-6 border-t border-brand-border">
                  <p className="text-brand-text-secondary text-[1.0625rem] mb-5">
                    對這個議題有疑問？歡迎與我們聊聊。
                  </p>
                  <a
                    href="https://lin.ee/o51JBHX"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-brand-gold text-brand-black px-8 py-3.5 rounded-full text-[1.0625rem] font-semibold hover:bg-brand-gold-soft transition-colors whitespace-nowrap"
                  >
                    <i className="ri-line-fill" />
                    加入 LINE 諮詢
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* CTA */}
        <section className="py-16 md:py-20">
          <div className="container-main">
            <div className="bg-brand-card border border-brand-border rounded-2xl p-8 md:p-14 text-center">
              <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2.125rem] leading-[1.4] mb-3">
                不確定自己的規劃是否跟得上市場變化？
              </h2>
              <p className="text-brand-text-secondary text-[1.1875rem] leading-[1.75] mb-8">
                先預約一次健診，把風險與缺口整理清楚。
              </p>
              <a
                href="https://lin.ee/o51JBHX"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-brand-gold text-brand-black px-10 py-4 rounded-full text-[1.125rem] font-semibold hover:bg-brand-gold-soft transition-colors whitespace-nowrap"
              >
                <i className="ri-line-fill" />
                加入 LINE 諮詢
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
